import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { GetPlayersProps } from "./models";

const getPlayers = async ({ page, pageSize, startDate, endDate, createdInPromo }: GetPlayersProps): Promise<any> => {
    let config = getConfig();
    try {
        const createQueryParams = new URLSearchParams();

        createQueryParams.set('page', page.toString());
        createQueryParams.set('pageSize', pageSize.toString());
        createQueryParams.set('startDate', startDate);
        createQueryParams.set('endDate', endDate);
        createQueryParams.set('createdInPromo', createdInPromo.toString());
        const response = await axios.get<any>(`/admin/players?${createQueryParams.toString()}`, config);
        return response.data;

    } catch (error) {
        return error as any;
    }
};

export { getPlayers };